<template>
  <div></div>
</template>
<script>
export default {
  name: "Openid",
  data () {
    return {
      Code: "",
      State: "",
      Session_state: ""
    };
  },
  mounted () {
    const urlParams = new URLSearchParams(window.location.search);

    this.Code = urlParams.get("code");
    this.State = urlParams.get("state");
    this.Session_state = urlParams.get("session_state");

    if (
      typeof this.Code === "undefined" ||
      this.Code === null ||
      this.Code === ""
    ) {
      sessionStorage.clear();
      window.open(this.$serviceoidc.getOidc(), "_self");
      // window.open(this.$serviceoidc.getOidc());
      return false;
    }

    if (
      typeof this.State === "undefined" ||
      this.State === null ||
      this.State === ""
    ) {
      sessionStorage.clear();
      window.open(this.$serviceoidc.getOidc(), "_self");
      // window.open(this.$serviceoidc.getOidc());
      return false;
    }

    //if (
    //  typeof this.Session_state === "undefined" ||
    //  this.Session_state === null ||
    //  this.Session_state === ""
    //) {
    //  sessionStorage.clear();
    //  window.open(this.$serviceoidc.getOidc(), "_self");
      // window.open(this.$serviceoidc.getOidc());
    //   return false;
    // }

    this.$storage.setOidcCode(this.Code);
    this.$storage.setOidcState(this.State);
   // this.$storage.setOidcSession_state(this.Session_state);

    this.$serviceoidc
      .postAccesToken(this.$storage.getOidcCode())
      .then(response => {
        if (response) {
          this.$storage.setSession("access_token", response.access_token);
          this.$router.replace("/Home");
        } else {
          sessionStorage.clear();
          window.open(this.$serviceoidc.getOidc(), "_self");
          // window.open(this.$serviceoidc.getOidc());
        }
      });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Openid.vue